module.exports = __webpack_public_path__ + "static/media/nav_close.18df47b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nav_close.svg
// module id = 1352
// module chunks = 0